import _toConsumableArray from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { Circle, Line } from '@antv/g';
import { sort, group, mean, bisector, minIndex } from 'd3-array';
import { deepMix, lowerFirst, throttle } from '@antv/util';
import { Tooltip as TooltipComponent } from '@antv/gui';
import { Constant, Identity } from '@antv/scale';
import { defined, subObject } from '../utils/helper';
import { isTranspose, isPolar } from '../utils/coordinate';
import { angle, sub } from '../utils/vector';
import { invert } from '../utils/scale';
import { selectG2Elements, createXKey, selectPlotArea, mousePosition, selectFacetG2Elements, createDatumof, selectElementByData } from './utils';
import { dataOf } from './event';
function getContainer(group, mount) {
  if (mount) return typeof mount === 'string' ? document.querySelector(mount) : mount;
  // @ts-ignore
  return group.getRootNode().defaultView.getConfig().container;
}
function getBounding(root) {
  var bbox = root.getBounds();
  var _bbox$min = _slicedToArray(bbox.min, 2),
    x1 = _bbox$min[0],
    y1 = _bbox$min[1],
    _bbox$max = _slicedToArray(bbox.max, 2),
    x2 = _bbox$max[0],
    y2 = _bbox$max[1];
  return {
    x: x1,
    y: y1,
    width: x2 - x1,
    height: y2 - y1
  };
}
function getContainerOffset(container1, container2) {
  var r1 = container1.getBoundingClientRect();
  var r2 = container2.getBoundingClientRect();
  return {
    x: r1.x - r2.x,
    y: r1.y - r2.y
  };
}
function createTooltip(container, x0, y0, position, enterable, bounding, containerOffset) {
  var tooltipElement = new TooltipComponent({
    className: 'tooltip',
    style: {
      x: x0,
      y: y0,
      container: containerOffset,
      data: [],
      bounding: bounding,
      position: position,
      enterable: enterable,
      title: '',
      offset: [10, 10],
      template: {
        prefixCls: 'g2-'
      },
      style: {
        '.g2-tooltip': {},
        '.g2-tooltip-title': {
          overflow: 'hidden',
          'white-space': 'nowrap',
          'text-overflow': 'ellipsis'
        }
      }
    }
  });
  container.appendChild(tooltipElement.HTMLTooltipElement);
  return tooltipElement;
}
function showTooltip(_ref) {
  var root = _ref.root,
    data = _ref.data,
    x = _ref.x,
    y = _ref.y,
    render = _ref.render,
    event = _ref.event,
    single = _ref.single,
    _ref$position = _ref.position,
    position = _ref$position === void 0 ? 'right-bottom' : _ref$position,
    _ref$enterable = _ref.enterable,
    enterable = _ref$enterable === void 0 ? false : _ref$enterable,
    mount = _ref.mount,
    bounding = _ref.bounding;
  var canvasContainer = root.getRootNode().defaultView.getConfig().container;
  var container = getContainer(root, mount);
  // All the views share the same tooltip.
  var parent = single ? canvasContainer : root;
  var b = bounding || getBounding(root);
  var containerOffset = getContainerOffset(canvasContainer, container);
  var _parent$tooltipElemen = parent.tooltipElement,
    tooltipElement = _parent$tooltipElemen === void 0 ? createTooltip(container, x, y, position, enterable, b, containerOffset) : _parent$tooltipElemen;
  var items = data.items,
    _data$title = data.title,
    title = _data$title === void 0 ? '' : _data$title;
  tooltipElement.update(Object.assign({
    x: x,
    y: y,
    data: items,
    title: title,
    position: position,
    enterable: enterable
  }, render !== undefined && {
    content: render(event, {
      items: items,
      title: title
    })
  }));
  parent.tooltipElement = tooltipElement;
}
function hideTooltip(_ref2) {
  var root = _ref2.root,
    single = _ref2.single,
    emitter = _ref2.emitter,
    _ref2$nativeEvent = _ref2.nativeEvent,
    nativeEvent = _ref2$nativeEvent === void 0 ? true : _ref2$nativeEvent,
    mount = _ref2.mount;
  if (nativeEvent) {
    emitter.emit('tooltip:hide', {
      nativeEvent: nativeEvent
    });
  }
  var canvasContainer = root.getRootNode().defaultView.getConfig().container;
  var parent = single ? canvasContainer : root;
  var tooltipElement = parent.tooltipElement;
  if (tooltipElement) {
    tooltipElement.hide();
  }
}
function destroyTooltip(root) {
  var tooltipElement = root.tooltipElement;
  if (tooltipElement) {
    tooltipElement.destroy();
    root.tooltipElement = undefined;
  }
}
function showUndefined(item) {
  var value = item.value;
  return Object.assign(Object.assign({}, item), {
    value: value === undefined ? 'undefined' : value
  });
}
function singleItem(element) {
  var datum = element.__data__;
  var title = datum.title,
    _datum$items = datum.items,
    items = _datum$items === void 0 ? [] : _datum$items;
  var newItems = items.filter(defined).map(function (_a) {
    var _a$color = _a.color,
      color = _a$color === void 0 ? itemColorOf(element) : _a$color,
      item = __rest(_a, ["color"]);
    return Object.assign(Object.assign({}, item), {
      color: color
    });
  }).map(showUndefined);
  return Object.assign(Object.assign({}, title && {
    title: title
  }), {
    items: newItems
  });
}
function groupNameOf(scale, datum) {
  var scaleColor = scale.color,
    scaleSeries = scale.series;
  var color = datum.color,
    series = datum.series;
  var invertAble = function invertAble(scale) {
    return scale && scale.invert && !(scale instanceof Identity) && !(scale instanceof Constant);
  };
  // For non constant color channel.
  if (invertAble(scaleSeries)) return scaleSeries.invert(series);
  if (series && series !== color) return series;
  if (invertAble(scaleColor)) {
    var name = scaleColor.invert(color);
    // For threshold scale.
    if (Array.isArray(name)) return null;
    return name;
  }
  return null;
}
function itemColorOf(element) {
  var fill = element.getAttribute('fill');
  var stroke = element.getAttribute('stroke');
  var datum = element.__data__;
  var _datum$color = datum.color,
    color = _datum$color === void 0 ? fill && fill !== 'transparent' ? fill : stroke : _datum$color;
  return color;
}
function unique(items) {
  var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (d) {
    return d;
  };
  var valueName = new Map(items.map(function (d) {
    return [key(d), d];
  }));
  return Array.from(valueName.values());
}
function groupItems(elements, scale, groupName) {
  var data = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : elements.map(function (d) {
    return d['__data__'];
  });
  var key = function key(d) {
    return d instanceof Date ? +d : d;
  };
  var T = unique(data.map(function (d) {
    return d.title;
  }), key).filter(defined);
  var newItems = data.flatMap(function (datum, i) {
    var element = elements[i];
    var _datum$items2 = datum.items,
      items = _datum$items2 === void 0 ? [] : _datum$items2,
      title = datum.title;
    var definedItems = items.filter(defined);
    // If there is only one item, use groupName as title by default.
    var useGroupName = groupName !== undefined ? groupName : items.length <= 1 ? true : false;
    return definedItems.map(function (_a) {
      var _a$color2 = _a.color,
        color = _a$color2 === void 0 ? itemColorOf(element) : _a$color2,
        name = _a.name,
        item = __rest(_a, ["color", "name"]);
      var name1 = useGroupName ? groupNameOf(scale, datum) || name : name || groupNameOf(scale, datum);
      return Object.assign(Object.assign({}, item), {
        color: color,
        name: name1 || title
      });
    });
  }).map(showUndefined);
  return Object.assign(Object.assign({}, T.length > 0 && {
    title: T.join(',')
  }), {
    items: unique(newItems, function (d) {
      return "(".concat(key(d.name), ", ").concat(key(d.value), ", ").concat(key(d.color), ")");
    })
  });
}
function updateRuleY(root, points, _a) {
  var plotWidth = _a.plotWidth,
    plotHeight = _a.plotHeight,
    mainWidth = _a.mainWidth,
    mainHeight = _a.mainHeight,
    startX = _a.startX,
    startY = _a.startY,
    transposed = _a.transposed,
    polar = _a.polar,
    insetLeft = _a.insetLeft,
    insetTop = _a.insetTop,
    rest = __rest(_a, ["plotWidth", "plotHeight", "mainWidth", "mainHeight", "startX", "startY", "transposed", "polar", "insetLeft", "insetTop"]);
  var defaults = Object.assign({
    lineWidth: 1,
    stroke: '#1b1e23',
    strokeOpacity: 0.5
  }, rest);
  var Y = points.map(function (p) {
    return p[1];
  });
  var X = points.map(function (p) {
    return p[0];
  });
  var y = mean(Y);
  var x = mean(X);
  var pointsOf = function pointsOf() {
    if (polar) {
      var r = Math.min(mainWidth, mainHeight) / 2;
      var cx = startX + insetLeft + mainWidth / 2;
      var cy = startY + insetTop + mainHeight / 2;
      var a = angle(sub([x, y], [cx, cy]));
      var x0 = cx + r * Math.cos(a);
      var y0 = cy + r * Math.sin(a);
      return [cx, x0, cy, y0];
    }
    if (transposed) return [startX, startX + plotWidth, y + startY, y + startY];
    return [x + startX, x + startX, startY, startY + plotHeight];
  };
  var _pointsOf = pointsOf(),
    _pointsOf2 = _slicedToArray(_pointsOf, 4),
    x1 = _pointsOf2[0],
    x2 = _pointsOf2[1],
    y1 = _pointsOf2[2],
    y2 = _pointsOf2[3];
  var createLine = function createLine() {
    var line = new Line({
      style: Object.assign({
        x1: x1,
        x2: x2,
        y1: y1,
        y2: y2
      }, defaults)
    });
    root.appendChild(line);
    return line;
  };
  // Only update rule with defined series elements.
  if (X.length > 0) {
    var ruleY = root.ruleY || createLine();
    ruleY.style.x1 = x1;
    ruleY.style.x2 = x2;
    ruleY.style.y1 = y1;
    ruleY.style.y2 = y2;
    root.ruleY = ruleY;
  }
}
function hideRuleY(root) {
  if (root.ruleY) {
    root.ruleY.remove();
    root.ruleY = undefined;
  }
}
// @todo Fill for composite g component.
function updateMarker(root, _ref3) {
  var data = _ref3.data,
    style = _ref3.style;
  if (root.markers) root.markers.forEach(function (d) {
    return d.remove();
  });
  var markers = data.map(function (d) {
    var _d = _slicedToArray(d, 2),
      _d$ = _d[0],
      color = _d$.color,
      element = _d$.element,
      point = _d[1];
    var fill = color ||
    // encode value
    element.style.fill || element.style.stroke || '#000';
    var shape = new Circle({
      style: Object.assign({
        cx: point[0],
        cy: point[1],
        fill: fill,
        r: 4,
        stroke: '#fff',
        strokeWidth: 2
      }, style)
    });
    return shape;
  });
  var _iterator = _createForOfIteratorHelper(markers),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var marker = _step.value;
      root.appendChild(marker);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  root.markers = markers;
}
function hideMarker(root) {
  if (root.markers) {
    root.markers.forEach(function (d) {
      return d.remove();
    });
    root.markers = [];
  }
}
function interactionKeyof(markState, key) {
  return Array.from(markState.values()).some(
  // @ts-ignore
  function (d) {
    var _a;
    return (_a = d.interaction) === null || _a === void 0 ? void 0 : _a[key];
  });
}
function maybeValue(specified, defaults) {
  return specified === undefined ? defaults : specified;
}
function isEmptyTooltipData(data) {
  var title = data.title,
    items = data.items;
  if (items.length === 0 && title === undefined) return true;
  return false;
}
function hasSeries(markState) {
  return Array.from(markState.values()).some(
  // @ts-ignore
  function (d) {
    var _a;
    return ((_a = d.interaction) === null || _a === void 0 ? void 0 : _a.seriesTooltip) && d.tooltip;
  });
}
/**
 * Show tooltip for series item.
 */
export function seriesTooltip(root, _a) {
  var elementsof = _a.elements,
    sortFunction = _a.sort,
    filterFunction = _a.filter,
    scale = _a.scale,
    coordinate = _a.coordinate,
    crosshairs = _a.crosshairs,
    render = _a.render,
    groupName = _a.groupName,
    emitter = _a.emitter,
    _a$wait = _a.wait,
    wait = _a$wait === void 0 ? 50 : _a$wait,
    _a$leading = _a.leading,
    leading = _a$leading === void 0 ? true : _a$leading,
    _a$trailing = _a.trailing,
    trailing = _a$trailing === void 0 ? false : _a$trailing,
    _a$startX = _a.startX,
    startX = _a$startX === void 0 ? 0 : _a$startX,
    _a$startY = _a.startY,
    startY = _a$startY === void 0 ? 0 : _a$startY,
    _a$body = _a.body,
    body = _a$body === void 0 ? true : _a$body,
    _a$single = _a.single,
    single = _a$single === void 0 ? true : _a$single,
    position = _a.position,
    enterable = _a.enterable,
    mount = _a.mount,
    bounding = _a.bounding,
    _a$disableNative = _a.disableNative,
    disableNative = _a$disableNative === void 0 ? false : _a$disableNative,
    _a$marker = _a.marker,
    marker = _a$marker === void 0 ? true : _a$marker,
    _a$style = _a.style,
    _style = _a$style === void 0 ? {} : _a$style,
    rest = __rest(_a, ["elements", "sort", "filter", "scale", "coordinate", "crosshairs", "render", "groupName", "emitter", "wait", "leading", "trailing", "startX", "startY", "body", "single", "position", "enterable", "mount", "bounding", "disableNative", "marker", "style"]);
  var elements = elementsof(root);
  var transposed = isTranspose(coordinate);
  var polar = isPolar(coordinate);
  var style = deepMix(_style, rest);
  var _coordinate$getOption = coordinate.getOptions(),
    plotWidth = _coordinate$getOption.innerWidth,
    plotHeight = _coordinate$getOption.innerHeight,
    mainWidth = _coordinate$getOption.width,
    mainHeight = _coordinate$getOption.height,
    insetLeft = _coordinate$getOption.insetLeft,
    insetTop = _coordinate$getOption.insetTop; // Split elements into series elements and item elements.
  var seriesElements = [];
  var itemElements = [];
  var _iterator2 = _createForOfIteratorHelper(elements),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var element = _step2.value;
      var data = element.__data__;
      var seriesX = data.seriesX;
      if (seriesX) seriesElements.push(element);else itemElements.push(element);
    }
    // Sorted elements from top to bottom visually,
    // or from right to left in transpose coordinate.
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  seriesElements.sort(function (a, b) {
    var index = transposed ? 0 : 1;
    var minY = function minY(d) {
      return d.getBounds().min[index];
    };
    return transposed ? minY(b) - minY(a) : minY(a) - minY(b);
  });
  // Get sortedIndex and X for each series elements
  var elementSortedX = new Map(seriesElements.map(function (element) {
    var data = element.__data__;
    var seriesX = data.seriesX;
    var seriesIndex = seriesX.map(function (_, i) {
      return i;
    });
    var sortedIndex = sort(seriesIndex, function (i) {
      return seriesX[+i];
    });
    return [element, [sortedIndex, seriesX]];
  }));
  var scaleX = scale.x; // Apply offset for band scale x.
  var offsetX = (scaleX === null || scaleX === void 0 ? void 0 : scaleX.getBandWidth) ? scaleX.getBandWidth() / 2 : 0;
  var abstractX = function abstractX(focus) {
    var _coordinate$invert = coordinate.invert(focus),
      _coordinate$invert2 = _slicedToArray(_coordinate$invert, 1),
      normalizedX = _coordinate$invert2[0];
    return normalizedX - offsetX;
  };
  var indexByFocus = function indexByFocus(focus, I, X) {
    var finalX = abstractX(focus);
    var _sort = sort([X[0], X[X.length - 1]]),
      _sort2 = _slicedToArray(_sort, 2),
      minX = _sort2[0],
      maxX = _sort2[1]; // Skip x out of range.
    if (finalX < minX || finalX > maxX) return null;
    var search = bisector(function (i) {
      return X[+i];
    }).center;
    var i = search(I, finalX);
    return I[i];
  };
  var elementsByFocus = function elementsByFocus(focus, elements) {
    var index = transposed ? 1 : 0;
    var x = focus[index];
    var extent = function extent(d) {
      var _d$getLocalBounds = d.getLocalBounds(),
        min = _d$getLocalBounds.min,
        max = _d$getLocalBounds.max;
      return sort([min[index], max[index]]);
    };
    return elements.filter(function (element) {
      var _extent = extent(element),
        _extent2 = _slicedToArray(_extent, 2),
        min = _extent2[0],
        max = _extent2[1];
      return x >= min && x <= max;
    });
  };
  var seriesData = function seriesData(element, index) {
    var data = element.__data__;
    return Object.fromEntries(Object.entries(data).filter(function (_ref4) {
      var _ref5 = _slicedToArray(_ref4, 1),
        key = _ref5[0];
      return key.startsWith('series') && key !== 'series';
    }).map(function (_ref6) {
      var _ref7 = _slicedToArray(_ref6, 2),
        key = _ref7[0],
        V = _ref7[1];
      var d = V[index];
      return [lowerFirst(key.replace('series', '')), d];
    }));
  };
  var update = throttle(function (event) {
    var mouse = mousePosition(root, event);
    if (!mouse) return;
    var bbox = root.getRenderBounds();
    var x = bbox.min[0];
    var y = bbox.min[1];
    var focus = [mouse[0] - startX, mouse[1] - startY];
    if (!focus) return;
    // Get selected item element.
    var selectedItems = elementsByFocus(focus, itemElements);
    // Get selected data item from both series element and item element.
    var selectedSeriesElements = [];
    var selectedSeriesData = [];
    for (var _i = 0, _seriesElements = seriesElements; _i < _seriesElements.length; _i++) {
      var element = _seriesElements[_i];
      var _elementSortedX$get = elementSortedX.get(element),
        _elementSortedX$get2 = _slicedToArray(_elementSortedX$get, 2),
        sortedIndex = _elementSortedX$get2[0],
        X = _elementSortedX$get2[1];
      var index = indexByFocus(focus, sortedIndex, X);
      if (index !== null) {
        selectedSeriesElements.push(element);
        var d = seriesData(element, index);
        var _x = d.x,
          _y = d.y;
        var p = coordinate.map([(_x || 0) + offsetX, _y || 0]);
        selectedSeriesData.push([Object.assign(Object.assign({}, d), {
          element: element
        }), p]);
      }
    }
    // Filter selectedSeriesData with different x,
    // make sure there is only one x closest to focusX.
    var SX = Array.from(new Set(selectedSeriesData.map(function (d) {
      return d[0].x;
    })));
    var closestX = SX[minIndex(SX, function (x) {
      return Math.abs(x - abstractX(focus));
    })];
    var filteredSeriesData = selectedSeriesData.filter(function (d) {
      return d[0].x === closestX;
    });
    var selectedData = [].concat(_toConsumableArray(filteredSeriesData.map(function (d) {
      return d[0];
    })), _toConsumableArray(selectedItems.map(function (d) {
      return d.__data__;
    })));
    // Get the displayed tooltip data.
    var selectedElements = [].concat(selectedSeriesElements, _toConsumableArray(selectedItems));
    var tooltipData = groupItems(selectedElements, scale, groupName, selectedData);
    // Sort items and filter items.
    if (sortFunction) {
      tooltipData.items.sort(function (a, b) {
        return sortFunction(a) - sortFunction(b);
      });
    }
    if (filterFunction) {
      tooltipData.items = tooltipData.items.filter(filterFunction);
    }
    // Hide tooltip with no selected tooltip.
    if (selectedElements.length === 0 || isEmptyTooltipData(tooltipData)) {
      hide();
      return;
    }
    if (body) {
      showTooltip({
        root: root,
        data: tooltipData,
        x: mouse[0] + x,
        y: mouse[1] + y,
        render: render,
        event: event,
        single: single,
        position: position,
        enterable: enterable,
        mount: mount,
        bounding: bounding
      });
    }
    if (crosshairs) {
      var points = filteredSeriesData.map(function (d) {
        return d[1];
      });
      var ruleStyle = subObject(style, 'crosshairs');
      updateRuleY(root, points, Object.assign(Object.assign({}, ruleStyle), {
        plotWidth: plotWidth,
        plotHeight: plotHeight,
        mainWidth: mainWidth,
        mainHeight: mainHeight,
        insetLeft: insetLeft,
        insetTop: insetTop,
        startX: startX,
        startY: startY,
        transposed: transposed,
        polar: polar
      }));
    }
    if (marker) {
      var markerStyles = subObject(style, 'marker');
      updateMarker(root, {
        data: filteredSeriesData,
        style: markerStyles
      });
    }
    emitter.emit('tooltip:show', Object.assign(Object.assign({}, event), {
      nativeEvent: true,
      data: {
        data: {
          x: invert(scale.x, abstractX(focus), true)
        }
      }
    }));
  }, wait, {
    leading: leading,
    trailing: trailing
  });
  var hide = function hide() {
    hideTooltip({
      root: root,
      single: single,
      emitter: emitter,
      mount: mount
    });
    if (crosshairs) hideRuleY(root);
    if (marker) hideMarker(root);
  };
  var onTooltipShow = function onTooltipShow(_ref8) {
    var nativeEvent = _ref8.nativeEvent,
      data = _ref8.data;
    if (nativeEvent) return;
    var x = data.data.x;
    var scaleX = scale.x;
    var x1 = scaleX.map(x);
    var _coordinate$map = coordinate.map([x1, 0.5]),
      _coordinate$map2 = _slicedToArray(_coordinate$map, 2),
      x2 = _coordinate$map2[0],
      y2 = _coordinate$map2[1];
    var _root$getRenderBounds = root.getRenderBounds(),
      _root$getRenderBounds2 = _slicedToArray(_root$getRenderBounds.min, 2),
      minX = _root$getRenderBounds2[0],
      minY = _root$getRenderBounds2[1];
    update({
      offsetX: x2 + minX,
      offsetY: y2 + minY
    });
  };
  var onTooltipHide = function onTooltipHide() {
    hideTooltip({
      root: root,
      single: single,
      emitter: emitter,
      nativeEvent: false,
      mount: mount
    });
  };
  emitter.on('tooltip:show', onTooltipShow);
  emitter.on('tooltip:hide', onTooltipHide);
  if (!disableNative) {
    root.addEventListener('pointerenter', update);
    root.addEventListener('pointermove', update);
    root.addEventListener('pointerleave', hide);
  }
  return function () {
    if (!disableNative) {
      root.removeEventListener('pointerenter', update);
      root.removeEventListener('pointermove', update);
      root.removeEventListener('pointerleave', hide);
    }
    emitter.off('tooltip:show', onTooltipShow);
    emitter.off('tooltip:hide', onTooltipHide);
    destroyTooltip(root);
    if (crosshairs) hideRuleY(root);
    if (marker) hideMarker(root);
  };
}
/**
 * Show tooltip for non-series item.
 */
export function tooltip(root, _ref9) {
  var elementsof = _ref9.elements,
    scale = _ref9.scale,
    render = _ref9.render,
    groupName = _ref9.groupName,
    sortFunction = _ref9.sort,
    filterFunction = _ref9.filter,
    emitter = _ref9.emitter,
    _ref9$wait = _ref9.wait,
    wait = _ref9$wait === void 0 ? 50 : _ref9$wait,
    _ref9$leading = _ref9.leading,
    leading = _ref9$leading === void 0 ? true : _ref9$leading,
    _ref9$trailing = _ref9.trailing,
    trailing = _ref9$trailing === void 0 ? false : _ref9$trailing,
    _ref9$groupKey = _ref9.groupKey,
    groupKey = _ref9$groupKey === void 0 ? function (d) {
      return d;
    } : _ref9$groupKey,
    _ref9$single = _ref9.single,
    single = _ref9$single === void 0 ? true : _ref9$single,
    position = _ref9.position,
    enterable = _ref9.enterable,
    datum = _ref9.datum,
    view = _ref9.view,
    mount = _ref9.mount,
    bounding = _ref9.bounding,
    _ref9$body = _ref9.body,
    body = _ref9$body === void 0 ? true : _ref9$body,
    _ref9$disableNative = _ref9.disableNative,
    disableNative = _ref9$disableNative === void 0 ? false : _ref9$disableNative;
  var elements = elementsof(root);
  var elementSet = new Set(elements);
  var keyGroup = group(elements, groupKey);
  var pointerover = throttle(function (event) {
    var element = event.target;
    if (!elementSet.has(element)) {
      hideTooltip({
        root: root,
        single: single,
        emitter: emitter,
        mount: mount
      });
      return;
    }
    var k = groupKey(element);
    var group = keyGroup.get(k);
    var data = group.length === 1 ? singleItem(group[0]) : groupItems(group, scale, groupName);
    // Sort items and sort.
    if (sortFunction) {
      data.items.sort(function (a, b) {
        return sortFunction(a) - sortFunction(b);
      });
    }
    if (filterFunction) {
      data.items = data.items.filter(filterFunction);
    }
    if (isEmptyTooltipData(data)) {
      hideTooltip({
        root: root,
        single: single,
        emitter: emitter,
        mount: mount
      });
      return;
    }
    var offsetX = event.offsetX,
      offsetY = event.offsetY;
    if (body) {
      showTooltip({
        root: root,
        data: data,
        x: offsetX,
        y: offsetY,
        render: render,
        event: event,
        single: single,
        position: position,
        enterable: enterable,
        mount: mount,
        bounding: bounding
      });
    }
    emitter.emit('tooltip:show', Object.assign(Object.assign({}, event), {
      nativeEvent: true,
      data: {
        data: dataOf(element, view)
      }
    }));
  }, wait, {
    leading: leading,
    trailing: trailing
  });
  var pointerout = function pointerout(event) {
    var element = event.target;
    if (!elementSet.has(element)) return;
    hideTooltip({
      root: root,
      single: single,
      emitter: emitter,
      mount: mount
    });
  };
  var onTooltipShow = function onTooltipShow(_ref10) {
    var nativeEvent = _ref10.nativeEvent,
      data = _ref10.data;
    if (nativeEvent) return;
    var element = selectElementByData(elements, data.data, datum);
    if (!element) return;
    var bbox = element.getBBox();
    var x = bbox.x,
      y = bbox.y,
      width = bbox.width,
      height = bbox.height;
    pointerover({
      target: element,
      offsetX: x + width / 2,
      offsetY: y + height / 2
    });
  };
  var onTooltipHide = function onTooltipHide() {
    var _ref11 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      nativeEvent = _ref11.nativeEvent;
    if (nativeEvent) return;
    hideTooltip({
      root: root,
      single: single,
      emitter: emitter,
      nativeEvent: false,
      mount: mount
    });
  };
  emitter.on('tooltip:show', onTooltipShow);
  emitter.on('tooltip:hide', onTooltipHide);
  if (!disableNative) {
    root.addEventListener('pointerover', pointerover);
    root.addEventListener('pointermove', pointerover);
    root.addEventListener('pointerout', pointerout);
  }
  return function () {
    if (!disableNative) {
      root.removeEventListener('pointerover', pointerover);
      root.removeEventListener('pointermove', pointerover);
      root.removeEventListener('pointerout', pointerout);
    }
    emitter.off('tooltip:show', onTooltipShow);
    emitter.off('tooltip:hide', onTooltipHide);
    destroyTooltip(root);
  };
}
export function Tooltip(options) {
  var shared = options.shared,
    crosshairs = options.crosshairs,
    series = options.series,
    name = options.name,
    _options$item = options.item,
    item = _options$item === void 0 ? function () {
      return {};
    } : _options$item,
    _options$facet = options.facet,
    facet = _options$facet === void 0 ? false : _options$facet,
    rest = __rest(options, ["shared", "crosshairs", "series", "name", "item", "facet"]);
  return function (target, viewInstances, emitter) {
    var container = target.container,
      view = target.view;
    var scale = view.scale,
      markState = view.markState,
      coordinate = view.coordinate; // Get default value from mark states.
    var defaultSeries = interactionKeyof(markState, 'seriesTooltip');
    var defaultShowCrosshairs = interactionKeyof(markState, 'crosshairs');
    var plotArea = selectPlotArea(container);
    var isSeries = maybeValue(series, defaultSeries);
    // For non-facet and series tooltip.
    if (isSeries && hasSeries(markState) && !facet) {
      return seriesTooltip(plotArea, Object.assign(Object.assign({}, rest), {
        elements: selectG2Elements,
        scale: scale,
        coordinate: coordinate,
        crosshairs: maybeValue(crosshairs, defaultShowCrosshairs),
        item: item,
        emitter: emitter
      }));
    }
    // For facet and series tooltip.
    if (isSeries && facet) {
      // Get sub view instances for this view.
      var facetInstances = viewInstances.filter(function (d) {
        return d !== target && d.options.parentKey === target.options.key;
      });
      var _elements = selectFacetG2Elements(target, viewInstances);
      // Use the scale of the first view.
      var _scale = facetInstances[0].view.scale;
      var bbox = plotArea.getBounds();
      var startX = bbox.min[0];
      var startY = bbox.min[1];
      // @todo Nested structure rather than flat structure for facet?
      // Add listener to the root area.
      // @ts-ignore
      return seriesTooltip(plotArea.parentNode.parentNode, Object.assign(Object.assign({}, rest), {
        elements: function elements() {
          return _elements;
        },
        scale: _scale,
        coordinate: coordinate,
        crosshairs: maybeValue(crosshairs, defaultShowCrosshairs),
        item: item,
        startX: startX,
        startY: startY,
        emitter: emitter
      }));
    }
    return tooltip(plotArea, Object.assign(Object.assign({}, rest), {
      datum: createDatumof(view),
      elements: selectG2Elements,
      scale: scale,
      coordinate: coordinate,
      groupKey: shared ? createXKey(view) : undefined,
      item: item,
      emitter: emitter,
      view: view
    }));
  };
}